import React from 'react';

// Decorative network graphic: scattered "device" nodes wired to a central trio of people.
const HeroNetwork = () => (
    <svg viewBox="0 0 480 420" fill="none" style={{ width: '100%', height: '100%' }} aria-hidden="true">
        <g opacity="0.55">
            <g stroke="#D7DCEC" strokeWidth="1.4">
                <line x1="30" y1="40" x2="90" y2="40" /><line x1="90" y1="40" x2="90" y2="95" />
                <line x1="150" y1="40" x2="150" y2="90" /><line x1="30" y1="100" x2="90" y2="100" />
                <line x1="380" y1="50" x2="440" y2="50" /><line x1="380" y1="50" x2="380" y2="100" />
                <line x1="30" y1="330" x2="90" y2="330" /><line x1="30" y1="330" x2="30" y2="280" />
                <line x1="410" y1="330" x2="450" y2="330" /><line x1="410" y1="330" x2="410" y2="280" />
            </g>
            <g fill="#E4E8F5" stroke="#C9CFE6" strokeWidth="1.2">
                <rect x="24" y="18" width="32" height="26" rx="6" /><circle cx="34" cy="30" r="2.6" fill="#AEB6D4" /><circle cx="46" cy="30" r="2.6" fill="#AEB6D4" />
                <rect x="130" y="18" width="32" height="26" rx="6" /><circle cx="140" cy="30" r="2.6" fill="#AEB6D4" /><circle cx="152" cy="30" r="2.6" fill="#AEB6D4" />
                <rect x="364" y="28" width="32" height="26" rx="6" /><circle cx="374" cy="40" r="2.6" fill="#AEB6D4" /><circle cx="386" cy="40" r="2.6" fill="#AEB6D4" />
                <rect x="14" y="308" width="32" height="26" rx="6" /><circle cx="24" cy="320" r="2.6" fill="#AEB6D4" /><circle cx="36" cy="320" r="2.6" fill="#AEB6D4" />
                <rect x="398" y="308" width="32" height="26" rx="6" /><circle cx="408" cy="320" r="2.6" fill="#AEB6D4" /><circle cx="420" cy="320" r="2.6" fill="#AEB6D4" />
                <rect x="80" y="78" width="26" height="22" rx="5" /><circle cx="88" cy="88" r="2.2" fill="#AEB6D4" /><circle cx="98" cy="88" r="2.2" fill="#AEB6D4" />
            </g>
        </g>
        <g stroke="#FC7785" strokeWidth="1.6" strokeDasharray="3 5" opacity="0.55">
            <line x1="90" y1="95" x2="200" y2="190" />
            <line x1="150" y1="90" x2="220" y2="180" />
            <line x1="380" y1="100" x2="270" y2="190" />
            <line x1="30" y1="280" x2="190" y2="230" />
            <line x1="410" y1="280" x2="290" y2="230" />
        </g>
        <g>
            <circle cx="240" cy="210" r="92" fill="url(#lpCmHeroG1)" />
            <circle cx="195" cy="185" r="30" fill="#fff" />
            <circle cx="195" cy="175" r="12" fill="#4A67FF" />
            <path d="M170 210c6-16 20-22 25-22s19 6 25 22" stroke="#4A67FF" strokeWidth="6" strokeLinecap="round" fill="none" />
            <circle cx="285" cy="185" r="30" fill="#fff" />
            <circle cx="285" cy="175" r="12" fill="#FC7785" />
            <path d="M260 210c6-16 20-22 25-22s19 6 25 22" stroke="#FC7785" strokeWidth="6" strokeLinecap="round" fill="none" />
            <circle cx="240" cy="250" r="30" fill="#fff" />
            <circle cx="240" cy="240" r="12" fill="#2ED9A5" />
            <path d="M215 275c6-16 20-22 25-22s19 6 25 22" stroke="#2ED9A5" strokeWidth="6" strokeLinecap="round" fill="none" />
        </g>
        <defs>
            <radialGradient id="lpCmHeroG1" cx="0.4" cy="0.35" r="0.75">
                <stop offset="0%" stopColor="#EDF0FF" />
                <stop offset="100%" stopColor="#DDE3FB" />
            </radialGradient>
        </defs>
    </svg>
);

const CommunityHeroSection = () => (
    <section className="lp-cm-hero">
        <div className="lp-cm-hero-inner">
            <div>
                <span className="lp-cm-eyebrow" data-lp-reveal><span className="dot" />Community</span>
                <h1 className="lp-cm-h1" data-lp-reveal data-lp-delay="60">In an era of growing isolation, <span className="lp-cm-h1">deals still get done by people.</span></h1>
                <p className="lp-cm-lead" data-lp-reveal data-lp-delay="120">Technology promised connection and gave us distance instead. Diligentsia is built the other way round: software does the grunt work, so the humans in your deal — founders, advisors and investors — can actually spend time and create value with each other.</p>
                <div className="lp-cm-hero-quote" data-lp-reveal data-lp-delay="180">
                    <img src={require('../../../../images/landing-pages/community/avatar-maham-zupash.png')} alt="Maham Zupash" />
                    <div className="lp-cm-hero-quote-card">
                        <p>“In the AI world of the future, software tools will be largely commoditised. The valuable businesses will be those with deep interconnected partner integrations and relationships”</p>
                        <span>Maham Zupash, Marketing Manager, Diligentsia</span>
                    </div>
                </div>
            </div>
            <div className="lp-cm-hero-art" data-lp-reveal data-lp-delay="140">
                <HeroNetwork />
            </div>
        </div>
    </section>
);

export default CommunityHeroSection;
